import { uuidModule } from "@/modules/uuid";
import { AssistantProjectModelData } from "@/store/assistant/types";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { generateDefaultOwnerScopes } from "@/store/sync/operations/helpers/common";
import { ICreateAssistantProjectOperation } from "@/store/sync/operations/types";
import { OptimisticSyncUpdate, SyncModelData } from "@/store/sync/types";

export class CreateAssistantProjectOperation extends BaseSyncOperation<ICreateAssistantProjectOperation> {
  get operationKind(): "CREATE_ASSISTANT_PROJECT" {
    return "CREATE_ASSISTANT_PROJECT";
  }

  public async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    return [this.generateProjectUpdate()];
  }

  async triggerRecompute(): Promise<void> {
    await this.store.assistantProjects.recompute(this.payload.id);
  }

  private generateProjectUpdate(): OptimisticSyncUpdate<AssistantProjectModelData> {
    return {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "UPSERTED",
      value: {
        model_id: this.payload.id,
        model_kind: "ASSISTANT_PROJECT",
        model_version: 1,
        model_data: {
          space_account_id: this.store.spaceAccounts.myPersonalSpaceAccountId,
          assistant_id: this.payload.assistant_id,
          title: this.payload.title,
          description: this.payload.description ?? null,
          status: this.payload.status,
          last_activity_at: this.committedAt,
          created_at: this.committedAt,
          updated_at: this.committedAt,
        },
        model_scopes: [generateDefaultOwnerScopes({ store: this.store })],
      },
    } as unknown as OptimisticSyncUpdate<AssistantProjectModelData>;
  }
}
